import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
} from "@angular/core";

import { Router } from "@angular/router";

import { Subscription } from "rxjs";

import { LayoutFacade } from "@hermes/aphrodite/layout";
import { BlockMediaTextDeprecated, CTA } from "@hermes/api-model-editorial";

import {
    EditoAnalyticsService,
    FULL_HERO_BLOC,
    FULL_HERO_IMAGE,
    FULL_MEDIA_CTA_CLASSNAME,
    FULL_MEDIA_IMAGE,
    FULL_MEDIA_VIDEO,
} from "@hermes/fragments/editorial-cta-resolver";
import { RouterService } from "@hermes/utils-generic/services/router";

import { SHOULD_PRELOAD_MEDIA, CHAPTERS_PARAGRAPH } from "../../core";

@Component({
    selector: "h-block-text-on-full-media",
    templateUrl: "./block-text-on-full-media.component.html",
    styleUrls: ["./block-text-on-full-media.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockTextOnFullMediaComponent implements OnInit, OnDestroy {
    public imageWidth: string = "100%";
    public maxHeightAdjustment: string = "0dvh";
    public ctaPath: string | undefined = undefined;
    public anchorClasses: string[] = [];
    public anchorCustomAttributesList: Array<string[] | undefined> = [];

    private subscription: Subscription = new Subscription();
    constructor(
        public layoutFacade: LayoutFacade,
        private routerService: RouterService,
        @Inject(CHAPTERS_PARAGRAPH)
        public blockMediaText: BlockMediaTextDeprecated,
        @Inject(SHOULD_PRELOAD_MEDIA) public shouldPreloadMedia: boolean,
        public router: Router,
        public detector: ChangeDetectorRef,
        private editoAnalyticsService: EditoAnalyticsService,
    ) {}

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
    public ngOnInit(): void {
        this.ctaPath =
            (this.blockMediaText?.token as CTA)?.path ||
            (Array.isArray(this.blockMediaText?.tokens) &&
                (this.blockMediaText.tokens as CTA[])[0]?.path) ||
            undefined;

        if (this.blockMediaText.tokens?.length) {
            this.anchorClasses = this.blockMediaText.tokens.map(
                (_) => FULL_MEDIA_CTA_CLASSNAME,
            );
            const isMediaVideoType = Boolean(
                this.blockMediaText.media?.videoUrl ||
                    this.blockMediaText.media?.mobileVideoUrl,
            );
            this.anchorCustomAttributesList = this.blockMediaText.tokens.map(
                (_) => [isMediaVideoType ? FULL_MEDIA_VIDEO : FULL_MEDIA_IMAGE],
            );
        }
    }

    public navigate(): void {
        if (this.ctaPath && !this.blockMediaText.media?.videoUrl) {
            this.editoAnalyticsService.sendFullMediaCTAClickEvent(
                FULL_HERO_IMAGE,
                FULL_HERO_BLOC,
                this.ctaPath,
            );
            this.routerService.spaRedirect(this.ctaPath);
        }
    }
}
